import React from 'react';
import { PrivateAdvisoryLocationTemplate } from './PrivateAdvisoryLocationTemplate';

const Weyburn: React.FC = () => {
  return (
    <PrivateAdvisoryLocationTemplate
      city="Weyburn"
      province="Saskatchewan"
      provinceCode="SK"
      population="11,329"
      description={`In Weyburn's "Opportunity City," successful agricultural families and energy sector leaders require sophisticated financial strategies that match their ambitions. PCM's Private Advisory delivers institutional-level expertise with the personal attention your success deserves - whether you're protecting multi-generational farm wealth or optimizing corporate structures in the energy sector.`}
      majorIndustries={['Agriculture Leaders', 'Energy Executives', 'Healthcare Professionals', 'Business Owners']}
      nearbyAreas={[
        'Estevan',
        'Southeast Saskatchewan',
        'Carlyle Region',
        'Oxbow Area'
      ]}
      clientSuccess={[
        {
          title: 'Multi-Generational Farm Succession',
          description: 'A prominent Weyburn agricultural family needed to transition their operation while minimizing tax impact and protecting family wealth.',
          outcome: 'Saved $1.2M in taxes through strategic insurance structures and coordinated planning with their accountant.'
        },
        {
          title: 'Energy Executive Protection',
          description: 'An oil industry leader required comprehensive disability coverage that standard policies wouldn\'t provide due to occupational risks.',
          outcome: 'Secured $5M in specialized coverage with terms tailored to industry-specific exposures.'
        },
        {
          title: 'Professional Corporation Optimization',
          description: 'A healthcare professional needed to restructure insurance holdings to avoid double taxation while maximizing estate value.',
          outcome: 'Implemented holding company structure saving $300K+ in lifetime taxes.'
        }
      ]}
    />
  );
};

export default Weyburn;